import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getReasonArriveLateSlice = createSlice({
  name: "getReasonArriveLate",
  initialState,
  reducers: {
    getReasonArriveLateStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getReasonArriveLateSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getReasonArriveLateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetReasonArriveLate: () => {
      return { ...initialState };
    },
  },
});

export const {
  getReasonArriveLateStart,
  getReasonArriveLateSuccess,
  getReasonArriveLateFailed,
  resetReasonArriveLate,
} = getReasonArriveLateSlice.actions;

export default getReasonArriveLateSlice.reducer;
